import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import PomocHelp from '../../elements/PomocHelp';
import FooterOne from '../../common/footer/FooterOne';

const Pomoc = () => {
    return (
        <>
        <HeaderOne />
        
        <PomocHelp />
                
        <FooterOne />
        </>
    )
}
    
export default Pomoc ;